export enum CurrentTournamentStoreStatus {
  Loading = 'loading',
  Canceling = 'canceling',
  Joining = 'joining',
  UpdatingInvitationStatus = 'updating_invitation_status',
  UpdatingSpectatorStatus = 'updating_spectator_status',
  ViewingAnimation = 'viewingAnimation',
  Withdrawing = 'withdrawing',
  Disqualification = 'disqualification',
  UpdatingMatchGameResults = 'updating_match_game_results',
  RunBracketMatch = 'run_bracket_match',
  UpdatingTrackedBy = 'updating_tracked_by',
  UpdatingAssets = 'updating_assets',
}
